/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

// KD11 — KD57200 WHITE dzieci 223x300 mm
// Pozycje tekstów (style inline, w mm):
//   top   = górna krawędź pola tekstowego
//   left  = środek tekstu (textAlign center + translateX(-50%)) albo lewa krawędź (textAlign left)
//   right = prawa krawędź pola (textAlign right)
// maxWidthN = maks. szerokość tekstu w px — dłuższy tekst zmniejsza czcionkę.
// Uwaga: lineHeight w stylu InlineEdit nie działa (nadpisuje go `font: inherit`), zawsze wynosi 1.5.
export const Kd11: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Wiktor");
  const [text2, setText2] = useState<string>("25.09.2022");
  const [text3, setText3] = useState<string>("ŚRODA");
  const [text4, setText4] = useState<string>("WAGA");
  const [text5, setText5] = useState<string>("50");
  const [text6, setText6] = useState<string>("godz. 12:22");
  const [text7, setText7] = useState<string>("3000");
  const [text8, setText8] = useState<string>("ŁOMŻA");
  const [text9, setText9] = useState<string>("gramów");
  const [text10, setText10] = useState<string>("cm");
  const text1BasicSize = 209;
  const text2BasicSize = 41;
  const text3BasicSize = 29;
  const text4BasicSize = 35;
  const text5BasicSize = 64;
  const text6BasicSize = 22;
  const text7BasicSize = 24;
  const text8BasicSize = 18;
  const text9BasicSize = 24;
  const text10BasicSize = 28;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const [fontSizeText7, setFontSizeText7] = useState<number>(text7BasicSize);
  const [fontSizeText8, setFontSizeText8] = useState<number>(text8BasicSize);
  const [fontSizeText9, setFontSizeText9] = useState<number>(text9BasicSize);
  const [fontSizeText10, setFontSizeText10] = useState<number>(text10BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "223mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const font1 = "VeryBerryPro";
  const font2 = "BookAntiqua-Bold";
  const maxWidth1 = 630;
  const maxWidth2 = 260;
  const maxWidth3 = 118;
  const maxWidth4 = 126;
  const maxWidth5 = 76;
  const maxWidth6 = 116;
  const maxWidth7 = 91;
  const maxWidth8 = 98;
  const maxWidth9 = 98;
  const maxWidth10 = 60;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
    fontFamily: string,
    maxWidth: number,
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px ${fontFamily}`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Czekamy na załadowanie fontu, inaczej canvas mierzy tekst fontem zastępczym.
  const ensureFont = (fontFamily: string) =>
    document.fonts.load(`1em ${fontFamily}`);

  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText1(
        adjustFontSize(
          text1,
          fontSizeText1,
          text1BasicSize,
          14,
          font1,
          maxWidth1,
        ),
      ),
    );
  }, [text1]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText2(
        adjustFontSize(
          text2,
          fontSizeText2,
          text2BasicSize,
          14,
          font2,
          maxWidth2,
        ),
      ),
    );
  }, [text2]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText3(
        adjustFontSize(
          text3,
          fontSizeText3,
          text3BasicSize,
          10,
          font2,
          maxWidth3,
        ),
      ),
    );
  }, [text3]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText4(
        adjustFontSize(
          text4,
          fontSizeText4,
          text4BasicSize,
          10,
          font2,
          maxWidth4,
        ),
      ),
    );
  }, [text4]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText5(
        adjustFontSize(
          text5,
          fontSizeText5,
          text5BasicSize,
          14,
          font2,
          maxWidth5,
        ),
      ),
    );
  }, [text5]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText6(
        adjustFontSize(
          text6,
          fontSizeText6,
          text6BasicSize,
          10,
          font2,
          maxWidth6,
        ),
      ),
    );
  }, [text6]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText7(
        adjustFontSize(
          text7,
          fontSizeText7,
          text7BasicSize,
          10,
          font2,
          maxWidth7,
        ),
      ),
    );
  }, [text7]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText8(
        adjustFontSize(
          text8,
          fontSizeText8,
          text8BasicSize,
          10,
          font2,
          maxWidth8,
        ),
      ),
    );
  }, [text8]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText9(
        adjustFontSize(
          text9,
          fontSizeText9,
          text9BasicSize,
          10,
          font2,
          maxWidth9,
        ),
      ),
    );
  }, [text9]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText10(
        adjustFontSize(
          text10,
          fontSizeText10,
          text10BasicSize,
          10,
          font2,
          maxWidth10,
        ),
      ),
    );
  }, [text10]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      null,
      false,
    );
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#ffffff",
        padding: "60px",
        position: "relative",
      }}
    >
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "0px",
          right: "0px",
          margin: "auto",
          color: "white",
          width: "150px",
          height: "50px",
        }}
      >
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "VeryBerryPro, BookAntiqua-Bold",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        {/* Wiktor */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: font1,
            color: "#593634",
            position: "absolute",
            top: "150.5mm",
            left: "113.3mm",
            width: `${maxWidth1 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "0.5px",
            fontVariantLigatures: "no-contextual",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 25.09.2022 */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: font2,
            color: "#593634",
            position: "absolute",
            top: "224.3mm",
            left: "115.9mm",
            width: `${maxWidth2 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* ŚRODA */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: font2,
            color: "#593634",
            position: "absolute",
            top: "244.8mm",
            left: "77.7mm",
            width: `${maxWidth3 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* WAGA */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: font2,
            color: "#593634",
            position: "absolute",
            top: "243.9mm",
            left: "117.5mm",
            width: `${maxWidth4 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 50 */}
        <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: font2,
            color: "#593634",
            position: "absolute",
            top: "239.7mm",
            left: "151.9mm",
            width: `${maxWidth5 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* godz. 12:22 */}
        <InlineEdit
          value={text6}
          setValue={setText6}
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: font2,
            color: "#593634",
            position: "absolute",
            top: "254mm",
            left: "77.7mm",
            width: `${maxWidth6 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "-0.4px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 3000 */}
        <InlineEdit
          value={text7}
          setValue={setText7}
          style={{
            fontSize: `${fontSizeText7}px`,
            fontFamily: font2,
            color: "#593634",
            position: "absolute",
            top: "254.5mm",
            left: "117.6mm",
            width: `${maxWidth7 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "0.3px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* ŁOMŻA */}
        <InlineEdit
          value={text8}
          setValue={setText8}
          style={{
            fontSize: `${fontSizeText8}px`,
            fontFamily: font2,
            color: "#593634",
            position: "absolute",
            top: "262.2mm",
            left: "77.6mm",
            width: `${maxWidth8 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "0.2px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* gramów */}
        <InlineEdit
          value={text9}
          setValue={setText9}
          style={{
            fontSize: `${fontSizeText9}px`,
            fontFamily: font2,
            color: "#593634",
            position: "absolute",
            top: "261mm",
            left: "117.4mm",
            width: `${maxWidth9 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* cm */}
        <InlineEdit
          value={text10}
          setValue={setText10}
          style={{
            fontSize: `${fontSizeText10}px`,
            fontFamily: font2,
            color: "#593634",
            position: "absolute",
            top: "259.5mm",
            left: "151.8mm",
            width: `${maxWidth10 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />

        <img
          src="/images/KD11.svg"
          alt=""
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: "0",
            left: "0",
            zIndex: "2",
          }}
        />
      </div>
    </div>
  );
};
